<section>
  <nes-heading tag="h1" size="6xl" [cypress]="'page_title'" class="nes-mb-1">
    {{ "COMPANY_DATA.TITLE" | translate }}
  </nes-heading>
  <nes-text class="nes-mb-10" size="sm">
    {{ "REQUIRED_FIELD" | translate }}
  </nes-text>
  <hr class="articleSeparator-title" />
</section>
<section>
  <form [formGroup]="formGroup" (ngSubmit)="formSubmit()">
    <section>
      <bca-company-search
        [selectedCompany]="selectedCompany$ | async"
        [companyFetching]="companyFetching$ | async"
        [companyLoading]="companyLoading$ | async"
        [companyRequiredError]="getCompanyErrorKey()"
        [searchFn]="companySearchFn"
        (close)="onCompanyClosed()"
        (focus)="onCompanyFocus()"
        (focusout)="onCompanyFocusOut()"
        (selected)="onCompanySelected($event)"
      >
      </bca-company-search>
    </section>

    <ng-container *ngIf="selectedCompany$ | async as selectedCompany">
      <section id="bca_company_employees_container" class="mb-4">
        <bca-company-employees
          [employeeRequiredError]="getEmployeeAmountErrorKey()"
          [employeeAmount]="(selectedCompany$ | async).employeeAmount"
          (selected)="onEmployeeAmountSelected($event)"
        >
        </bca-company-employees>
      </section>

      <section class="mb-3 animated fadeIn">
        <h1 class="headingXL">
          {{ "COMPANY_DATA.REPRESENTATIVE_TITLE" | translate }}
        </h1>
        <p>
          {{ "COMPANY_DATA.REPRESENTATIVE_DESCRIPTION" | translate }}
        </p>
        <hr class="articleSeparator" />

        <section *ngIf="hasMultipleUsers$ | async" class="mb-3">
          <div class="formfield">
            <div class="nes-flex nes-items-center">
              <div
                class="checkbox formfield__checkbox"
                [cypress]="'check_user'"
              >
                <div class="nes-flex nes-items-center">
                  <input
                    [checked]="selectUserFromHistoryChecked$ | async"
                    (change)="
                      onSelectUserFromHistoryChecked($event.target.checked)
                    "
                    type="checkbox"
                    class="checkbox__input"
                    id="selectUserFromHistoryChecked"
                  />
                  <label
                    class="checkbox__label"
                    for="selectUserFromHistoryChecked"
                    tabindex="-1"
                  >
                    {{
                      "COMPANY_DATA.INPUT.USER_HISTORY.LABEL_CHECKBOX"
                        | translate
                    }}
                  </label>
                  <bca-tool-tip
                    *ngIf="!(selectUserFromHistoryChecked$ | async)"
                    textOrKey="COMPANY_DATA.INPUT.USER_HISTORY.TOOLTIP"
                  >
                  </bca-tool-tip>
                </div>

              </div>
            </div>
          </div>
          <bca-choose-user
            *ngIf="selectUserFromHistoryChecked$ | async"
            [users]="users$ | async"
            [selectedUserId]="selectedUserId$ | async"
            (selected)="onUserFromHistorySelected($event)"
          >
          </bca-choose-user>
        </section>

        <bca-user-form
          [cypress]="'representative'"
          [userForm]="getControl('representative')"
          [middleNames]="middleNames$ | async"
          [checkedSignatoryStatus]="signatoryStatus$ | async"
          [hasEmailTooltip]="true"
          (sendError)="handleUserFormError($event)"
          (resetStatus)="resetSignatoryStatus()"
        >
        </bca-user-form>
      </section>

      <section>
        <div class="formfield">
          <div
            [cypress]="'check_contactPerson'"
            class="checkbox formfield__checkbox"
          >
            <label for="diffContactPersonChecked" tabindex="-1">
              {{ "COMPANY_DATA.INPUT.CONTACT_PERSON.LABEL" | translate }}
            </label>
            <bca-tool-tip
              *ngIf="!(differentContactPersonChecked$ | async)"
              textOrKey="COMPANY_DATA.INPUT.CONTACT_PERSON.TOOLTIP"
            >
            </bca-tool-tip>
            <div class="nes-flex nes-mt-2">
              <nes-selectable
                #contactPersonButtonTrue
                class="nes-w-5/12 sm:nes-w-3/12 nes-flex nes-justify-items-center nes-mr-3"
                id="'contactPersonButtonTrue'"
                nes-id="'contactPersonButtonTrue'"
                name="option-yes"
                [checked]="differentContactPersonChecked$ | async"
                (nesOnClick)="onDifferentContactPersonChecked(true)"
                [label]="'COMPANY_DATA.TOGGLE_BUTTON.YES' | translate"
              >
                <div class="nes-py-4 nes-text-center">
                  {{ "COMPANY_DATA.TOGGLE_BUTTON.YES" | translate }}
                </div>
              </nes-selectable>

              <nes-selectable
                #contactPersonButtonFalse
                class="nes-w-5/12 sm:nes-w-3/12 nes-flex nes-justify-items-center nes-mr-3"
                id="'contactPersonButtonFalse'"
                nes-id="'contactPersonButtonFalse'"
                name="option-no"
                [checked]="(differentContactPersonChecked$ | async) === false"
                (nesOnClick)="onDifferentContactPersonChecked(false)"
                [label]="'COMPANY_DATA.TOGGLE_BUTTON.NO' | translate"
              >
                <div class="nes-py-4 nes-text-center">
                  {{ "COMPANY_DATA.TOGGLE_BUTTON.NO" | translate }}
                </div>
              </nes-selectable>
            </div>
          </div>
        </div>

        <ng-container *ngIf="differentContactPersonChecked$ | async">
          <section class="mb-3 animated fadeIn">
            <h1 class="headingXL">
              {{ "COMPANY_DATA.CONTACTPERSON_TITLE" | translate }}
            </h1>
            <p>
              {{ "COMPANY_DATA.CONTACTPERSON_DESCRIPTION" | translate }}
            </p>
            <hr class="articleSeparator" />
            <section class="mt-3" id="scroll_contactPerson">
              <bca-user-form
                [cypress]="'contactPerson'"
                [userForm]="getControl('contactPerson')"
                [middleNames]="middleNames$ | async"
                (sendError)="handleUserFormError($event)"
              >
              </bca-user-form>
            </section>
          </section>
        </ng-container>
      </section>
    </ng-container>

    <div class="actionBar mt-4">
      <div class="actionBar__container actionBar__container--left">
        <a
          (click)="previousRoute()"
          [cypress]="'previous_page'"
          class="backArrowLink backArrowLink--compact backArrowLink--button actionBar__item"
        >
          <span class="backArrowLink__text">{{
            "BUTTON.BACK" | translate
          }}</span>
        </a>
      </div>
      <div class="actionBar__container actionBar__container--right">
        <nes-button
          icon-trailing="true"
          [cypress]="'next_page'"
          type="submit"
          nes-id="to_verify_page"
          id="to_verify_page"
          variant="brand"
          (nesOnClick)="formSubmit()"
        >
          {{ "BUTTON.VERIFY" | translate }}
        </nes-button>
      </div>
    </div>
  </form>
</section>
